import React from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { useSchedule } from '../context/ScheduleContext'
import './ScheduleCalendar.styles.scss'

export default function ScheduleCalendar({ upcoming }) {
  const { schedule } = useSchedule()

  // if upcoming is a number, render the next N days list
  if (typeof upcoming === 'number') {
    // build an array of Date objects for today + next (upcoming−1) days
    const days = Array.from({ length: upcoming }, (_, i) => {
      const d = new Date()
      d.setDate(d.getDate() + i)
      return d
    })

    return (
      <div className="upcoming-schedule">
        {days.map(d => {
          const dateStr = d.toISOString().slice(0, 10)
          const items   = schedule[dateStr] || []

          return (
            <div key={dateStr} className="upcoming-day">
              <h3>
                {d.toLocaleDateString(undefined, {
                  weekday: 'short',
                  month:   'short',
                  day:     'numeric',
                })}
              </h3>
              {items.length > 0 ? (
                <ul>
                  {items.map(it => (
                    <li key={it.fid}>{it.attributes.Name}</li>
                  ))}
                </ul>
              ) : (
                <p className="no-events">No events</p>
              )}
            </div>
          )
        })}
      </div>
    )
  }

  // otherwise full-calendar month view
  const events = Object.entries(schedule).flatMap(([date, items]) =>
    items.map(item => ({
      id:    item.fid.toString(),
      title: item.attributes.Name,
      start: date,
    }))
  )

  return (
    <FullCalendar
      plugins={[dayGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      events={events}
      height="auto"
    />
  )
}
